import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { IProductDataV2 } from '@df/catalog/product/product';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { ProductDecorator } from '../../../model/product/product.decorator';
import { AspectRatioPipe } from '../ui/aspect-ratio.pipe';
import { IProductBannerBlockDataContent, ProductBannerBlockComponent } from './block/product-banner-block.component';

@Component({
    selector: 'product-banner',
    templateUrl: './product-banner.component.html',
    standalone: true,
    imports: [AspectRatioPipe, CommonModule, DfImageDirective, HrefComponent, ProductBannerBlockComponent, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBannerComponent extends ProductComponentDef<ProductDecorator<IProductDataV2>> {
    priority = input(false);

    hasContentImage = -1;

    handleBannerContentChange(content: IProductBannerBlockDataContent) {
        if (content) {
            this.hasContentImage = !!content.image ? 1 : 0;

            this.detectChanges();
        }
    }
}
